import React from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
// react component used to create a calendar with events on it
import BigCalendar from "react-big-calendar";
// dependency plugin for react-big-calendar
import moment from "moment";
import "moment/locale/es";
import { duration } from "moment";
// react component used to create alerts
import SweetAlert from "react-bootstrap-sweetalert";

import { PanelHeader, Button } from "components";

import { events, newEvents, calendars } from "variables/general.jsx";

import ReactCalendar from "@toast-ui/react-calendar";
import "tui-calendar/dist/tui-calendar.css";
import "tui-date-picker/dist/tui-date-picker.css";
import "tui-time-picker/dist/tui-time-picker.css";
import ReactDOMServer from "react-dom/server";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
const CITA = "cita";
const daynames = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

//function to group array by param. Usage:
//        const groupByParamA = groupBy('paramA');
//        const groupedElements = groupByParamA(elements);
const groupBy = key => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

var latestClick = [];
var buttonStackLoaded = false;
const DIA = "dia";
const SEMANA = "semana";
const SEIS_SEMANAS = "6semanas";
const ANTERIOR = "anterior";
const HOY = "hoy";
const SIGUIENTE = "siguiente";
const WAIT_INTERVAL = 1000;

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

class Calendar extends React.Component {
  constructor(props) {
    super(props);
    let existingEvents = null;
    if (this.props.mainState.homeVisits && this.props.mainState.homeVisits.list) existingEvents = this.props.mainState.homeVisits.list;
    var now = moment();
    var monday = now.clone().weekday(0);//.subtract(5, 'weeks');
    var sunday = now.clone().weekday(6);//.add(5, 'weeks');
    this.state = {
      events: [],
      newEvents: existingEvents || [],
      alert: null,
      date_day_min: monday,
      date_day_max: sunday,
      homeVisits: [],
      buttonStack: [],
      showLog: false
    };
    // console.log("this.props.mainState", this.props.mainState);
    if ("calendar" in this.props.mainState.sessionConfig) {
      let existingConfig = this.props.mainState.sessionConfig["calendar"];
      this.state = existingConfig;
    }
    // console.log("state", this.state);
    this.hideAlert = this.hideAlert.bind(this);
    this.onBeforeCreateSchedule = this.onBeforeCreateSchedule.bind(this);
    this.onBeforeDeleteSchedule = this.onBeforeDeleteSchedule.bind(this);
    this.onBeforeUpdateSchedule = this.onBeforeUpdateSchedule.bind(this);
    this.onClickSchedule = this.onClickSchedule.bind(this);
    this.cancelScheduleChanges = cancelScheduleChanges.bind(this);
    this.updateHomeVisit = this.updateHomeVisit.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
    this.addButtonToStack = this.addButtonToStack.bind(this);
    this.loadButtonStack = this.loadButtonStack.bind(this);
    this.loadRangeEvents = this.loadRangeEvents.bind(this);    
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    if (!(this.state.buttonStack && this.state.buttonStack.length > 0)) {
      this.props.userData.searchHomeVisits("", this.state.date_day_min, this.state.date_day_max);
    }
    this.props.userData.getCalendarsList();
    this.props.userData.getHomeVisitsLog();
    buttonStackLoaded = false;
    // let calendar = this.refs.cal.calendarInst;
    // calendar.setOptions({week: {startDayOfWeek: 1}}, true);
  }
  componentWillUnmount() {
    // console.log("unmounting calendar");
    this.props.saveSessionConfig("calendar", this.state);
  }
  handleChange() {
    clearTimeout(this.timer);
    this.timer = setTimeout(this.loadRangeEvents, WAIT_INTERVAL);
  }
  addButtonToStack(button) {
    let buttonStack = this.state.buttonStack;
    if (!buttonStack) buttonStack = [];
    buttonStack.push(button);
    this.setState({ buttonStack: buttonStack });
  }
  loadButtonStack() {
    // console.log("loading button Stack", this.state.buttonStack);
    if (this.state.buttonStack && this.state.buttonStack.length > 0) {
      let buttonStack = this.state.buttonStack;
      buttonStack.map(button => {
        // console.log("vamos a pulsar el botón --> ", button);
        let calendar = this.refs.cal.calendarInst;
        // console.log("calendar", calendar);
        let currentView = "";
        switch (button) {
          case DIA:
            // console.log("pulsando el botón --> ", button);
            calendar.changeView("day");
            currentView = "day";
            break;
          case SEMANA:
            // console.log("pulsando el botón --> ", button);
            calendar.changeView("week");
            currentView = "week";
            break;
          case SEIS_SEMANAS:
            // console.log("pulsando el botón --> ", button);
            calendar.setOptions({month: {visibleWeeksCount: 6}}); // or null
            calendar.changeView("month", false);
            currentView = "month";
            break;
          case ANTERIOR:
            // console.log("pulsando el botón --> ", button);
            calendar.prev();
            break;
          case HOY:
            // console.log("pulsando el botón --> ", button);
            calendar.today();
            break;
          case SIGUIENTE:
            // console.log("pulsando el botón --> ", button);
            calendar.next();
            break;
        }
        this.setState({ currentView: currentView });
        setTimeout((function() {
          this.scrollToBottom();
        }).bind(this), 200);
      });
    }
  }
  scrollToBottom() {
    let last = document.getElementById("ultimo");
    last.scrollIntoView({behavior: "auto"});
    // console.log("scroll to bottom");
  }
  componentDidUpdate(prevProps, prevState) {
    // console.log("this.state in componentDidUpdate(Calendar)", this.state);
    // console.log("this.refs.cal", this.refs.cal);
    // console.log("this.refs.cal.calendarInst", this.refs.cal ? this.refs.cal.calendarInst : null);
    // console.log("this.refs.cal.calendarInst.getDateRangeStart()", this.refs.cal ? this.refs.cal.calendarInst.getDateRangeStart() : null);
    // console.log("this.refs.cal.calendarInst.getDateRangeEnd()", this.refs.cal ? this.refs.cal.calendarInst.getDateRangeEnd() : null);

    // console.log("");
    // console.log("#######################################################");
    // console.log("     Update calendar, time:", moment().toISOString());
    // console.log("#######################################################");
    // console.log("");
    if (this.refs.cal && !buttonStackLoaded) {
      buttonStackLoaded = true;
      this.loadButtonStack();
    }
  }
  loadRangeEvents() {
    if (this.refs.cal && this.refs.cal.calendarInst) {
      let rangeStart = moment(this.refs.cal.calendarInst.getDateRangeStart().getTime());
      let rangeEnd = moment(this.refs.cal.calendarInst.getDateRangeEnd().getTime());
      // console.log("LOAD RANGE START", rangeStart);
      // console.log("LOAD RANGE END", rangeEnd);
      this.props.userData.searchHomeVisits("", rangeStart, rangeEnd);
    }
  }
  getEventColor(type) {
    let resultStyle = {};
    let resultText = {};
    type = parseInt(type);
    switch (type) {
      case 243:
        resultText = "Instalación WiFi";
        resultStyle = "btn-primary";
        return "#46B98A"
        break;
      case 244:
        resultText = "Incidencia";
        resultStyle = "btn-danger";
        return "#c0392b"
        break;
      case 245:
        resultText = "Configuración";
        resultStyle = "btn-info";
        return "#5279BF"
        break;
      case 246:
        resultText = "Servicio extra";
        resultStyle = "btn-info";
        return "#5279BF"
        break;
      case 256:
        resultText = "Instalación fibra";
        resultStyle = "btn-warning";
        return "#FFB236"
        break;
      default:
        resultText = "Error en el tipo";
        resultStyle = "btn-default";
        return "#888888"
        break;
    }
  }
  selectedEvent(event) {
    alert(event.title);
  }
  // shouldComponentUpdate(nextProps) {
  //   if (!this.props.mainState.lastLoadedCalendar) return true;
  //   return this.props.mainState.lastLoadedCalendar < nextProps.mainState.lastLoadedCalendar;
  // }
  addNewEventAlert(slotInfo) {
    // console.log("");
    // console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~");
    // console.log("     addNewEventAlert, time:", moment().toISOString());
    // console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~");
    // console.log("");
    this.setState({
      alert: (
        <SweetAlert
          input
          showCancel
          style={{ display: "block", marginTop: "-100px" }}
          title="Input something"
          onConfirm={e => this.addNewEvent(e, slotInfo)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
        />
      )
    });
  }
  addNewEvent(e, slotInfo) {
    var newEvents = this.state.events;
    newEvents.push({
      title: e,
      start: slotInfo.start,
      end: slotInfo.end
    });
    this.setState({
      alert: null,
      events: newEvents
    });
  }
  hideAlert() {
    this.setState({
      alert: null,
      scheduleUpdating: null
    });
  }
  eventColors(event, start, end, isSelected) {
    var backgroundColor = "event-";
    event.color
      ? (backgroundColor = backgroundColor + event.color)
      : (backgroundColor = backgroundColor + "default");
    return {
      className: backgroundColor
    };
  }
  onClickSchedule(e) {
    // console.log("redirect citas", e);
    let schedule = e.schedule;
    let lastClick = 0;
    if (schedule.id in latestClick) {
      lastClick = latestClick[schedule.id];
      let now = moment();
      if (now - lastClick < 1500)
        // console.log("URL", "/citas/" + e.schedule.id);
        this.setState({ lastViewed: parseInt(e.schedule.id) });
        this.redirectTo("/citas/" + e.schedule.id);
    }
    latestClick[schedule.id] = moment();

    // this.setState({ redirect: "/citas/" + e.schedule.id });
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  onBeforeCreateSchedule(scheduleData) {
    // console.log("CREATE SCHEDULE");
    // console.log(scheduleData);
    this.props.userData.createHomeVisitFromCalendar(scheduleData);
    // this.setState({ redirect: "/citas/nueva" });
    this.redirectTo("/citas/nueva");
    return;

    const schedule = {
      id: String(Math.random()),
      title: scheduleData.title,
      isAllDay: scheduleData.isAllDay,
      start: scheduleData.start,
      end: scheduleData.end,
      category: scheduleData.isAllDay ? "allday" : "time",
      dueDateClass: "",
      location: scheduleData.location,
      raw: {
        class: scheduleData.raw["class"]
      },
      state: scheduleData.state,
      calendarId: scheduleData.calendarId
    };
    console.log(this.refs);
    this.refs.cal.calendarInst.createSchedules([schedule]);
  }
  onBeforeDeleteSchedule(res) {
    console.log("DELETE SCHEDULE");
    console.log(res);
    const { id, calendarId } = res.schedule;
    let calendar = this.refs.cal.calendarInst;
    calendar.deleteSchedule(id, calendarId);
  }
  onBeforeUpdateSchedule(e) {
    // console.log("UPDATE SCHEDULE");
    // console.log(e);
    const { schedule, changes } = e;

    let calendar = this.refs.cal.calendarInst;
    // console.log("CHANGES TO UPDATE", {
    //   schedule_id: schedule.id,
    //   calendar: schedule.calendarId,
    //   changes: changes
    // });
    
    if (changes.start && schedule.start.getTime() !== changes.start.getTime()) {
      this.setState({
        alert: (
          <SweetAlert
            // input
            showCancel
            style={{ display: "block", marginTop: "-100px" }}
            title="¿Aplicar cambios?"
            onConfirm={e => {
              console.log("HOME VISIT UPDATE CONFIRMED");
              this.updateHomeVisit(schedule);
              this.hideAlert();
            }}
            onCancel={() => {
              this.cancelScheduleChanges();
              this.hideAlert();
            }}
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            confirmBtnText="Guardar"
            cancelBtnText="Descartar"
          />
        ),
        scheduleUpdating: { ...schedule }
      });
    } else if (changes.end && schedule.end.getTime() !== changes.end.getTime()) {
      this.setState({
        alert: (
          <SweetAlert
            // input
            showCancel
            style={{ display: "block", marginTop: "-100px" }}
            title="¿Aplicar cambios?"
            onConfirm={e => {
              // console.log("HOME VISIT UPDATE CONFIRMED");
              this.updateHomeVisit(schedule);
              this.hideAlert();
            }}
            onCancel={() => {
              this.cancelScheduleChanges();
              this.hideAlert();
            }}
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            confirmBtnText="Guardar"
            cancelBtnText="Descartar"
          />
        ),
        scheduleUpdating: { ...schedule }
      });
    }

    calendar.updateSchedule(
      schedule.id,
      schedule.calendarId,
      changes,
      true
    );
  }
  updateHomeVisit(schedule) {
    // console.log("EDITANDO HOME VISIT");
    // console.log("schedule", schedule);
    // console.log("schedule.start", schedule.start);
    // console.log("schedule.start.getTime()", schedule.start.getTime());
    // console.log("moment(schedule.start.getTime())", moment(schedule.start.getTime()));
    // console.log("(moment(schedule.start.getTime())).format(YYYY-MM-DD)", (moment(schedule.start.getTime())).format("YYYY-MM-DD"));
    let duration = (schedule.end.getTime() - schedule.start.getTime()) / (1000 * 60 * 60);
    let homeVisit = {
      date: moment(schedule.start.getTime()).format("YYYY-MM-DD") + " " + moment(schedule.start.getTime()).format("HH:mm"),
      duration: duration,
      home_visit_id: schedule.id
    };
    // console.log("homeVisit", homeVisit);
    this.props.userData.editHomeVisitDate(homeVisit, this.state.date_day_min, this.state.date_day_max);
  }
  render() {
    // if (this.state.redirect) this.redirectTo(this.state.redirect);
    let events = [];
    let homeVisits = [];
    if (this.props.mainState.homeVisits && this.props.mainState.homeVisits.calendar) {
      events = this.props.mainState.homeVisits.calendar;
    }
    let showLoadingLogMessage = this.props.mainState.isSearchingHomeVisitsLog || !this.props.mainState.log || 
      !this.props.mainState.log.homeVisits || !("all" in this.props.mainState.log.homeVisits);
    let calendarRange = null;
    if (this.refs.cal && this.refs.cal.calendarInst) {
      let rangeStartUNIX = this.refs.cal.calendarInst.getDateRangeStart().getTime();
      let rangeEndUNIX = this.refs.cal.calendarInst.getDateRangeEnd().getTime();
      let rangeStart = moment(rangeStartUNIX).format("DD/MM/YYYY");
      let rangeEnd = moment(rangeEndUNIX).format("DD/MM/YYYY");
      calendarRange = rangeStart;
      if (rangeStart !== rangeEnd) {
        calendarRange = "Mostrando del " + rangeStart + " al " + rangeEnd;
      }
    }
    return (
      <div>
        <PanelHeader
          size="sm"
          // content={
          //   <div className="header text-center">
          //     <h2 className="title">Calendario</h2>
          //     <p className="category">
          //       Calendario de eventos
          //     </p>
          //   </div>
          // }
        />
        <div className={"content " + (this.refs.cal ? this.refs.cal.calendarInst.getViewName() : "")}>
          {this.state.alert}
          <Row>
            <Col>
              <Card className="card-calendar">
                <CardBody>
                  <Button
                    // icon
                    round
                    key={"dayViewButton"}
                    color="info"
                    onClick={() => {
                      this.refs.cal.calendarInst.changeView("day");
                      this.addButtonToStack(DIA);
                      this.handleChange();
                      this.setState({ currentView: "day" });
                    }}
                    // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                    // leftLabel={"now-ui-icons ui-1_simple-add"}
                  >
                    Día
                  </Button>
                  <Button
                    // icon
                    round
                    key={"weekViewButton"}
                    color="info"
                    onClick={() => {
                      this.refs.cal.calendarInst.changeView("week");
                      this.addButtonToStack(SEMANA);
                      this.handleChange();
                      this.setState({ currentView: "week" });
                    }}
                    // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                    // leftLabel={"now-ui-icons ui-1_simple-add"}
                  >
                    Semana
                  </Button>
                  <Button
                    // icon
                    round
                    key={"6weekViewButton"}
                    color="info"
                    onClick={() => {
                      let calendar = this.refs.cal.calendarInst;
                      calendar.setOptions({month: {visibleWeeksCount: 6}}); // or null
                      calendar.changeView("month", false);
                      this.addButtonToStack(SEIS_SEMANAS);
                      this.handleChange();
                      this.setState({ currentView: "month" });
                    }}
                    // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                    // leftLabel={"now-ui-icons ui-1_simple-add"}
                  >
                    6 semanas
                  </Button>
                  <Button
                    icon
                    round
                    key={"previousViewButton"}
                    color="info"
                    onClick={() => {
                      let calendar = this.refs.cal.calendarInst;
                      calendar.prev();
                      this.handleChange();
                      this.addButtonToStack(ANTERIOR);
                    }}
                    // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                    leftLabel={"now-ui-icons arrows-1_minimal-left"}
                  />
                  <Button
                    // icon
                    round
                    key={"todayViewButton"}
                    color="info"
                    onClick={() => {
                      let calendar = this.refs.cal.calendarInst;
                      calendar.today();
                      this.handleChange();
                      this.addButtonToStack(HOY);
                    }}
                    // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                    // leftLabel={"now-ui-icons arrows-1_minimal-right"}
                  >Hoy</Button>
                  <Button
                    icon
                    round
                    key={"nextViewButton"}
                    color="info"
                    onClick={() => {
                      let calendar = this.refs.cal.calendarInst;
                      calendar.next();
                      this.handleChange();
                      this.addButtonToStack(SIGUIENTE);
                    }}
                    // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                    leftLabel={"now-ui-icons arrows-1_minimal-right"}
                  />
                  <Link to={"/citas/nueva"}>
                    <Button round color="primary">
                      <i className="now-ui-icons ui-1_simple-add" /> Nueva cita
                    </Button>
                  </Link>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {this.props.mainState.isSearchingHomeVisits && <Row>
            <Col xs={12} className="text-center txt-white">
              <Card color="primary">
                <CardBody>
                  <div>
                    <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando eventos del calendario
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>}
          {!this.props.mainState.isSearchingHomeVisits && <Row>
            <Col xs={12} className="text-center txt-white">
              <Card color="info" onClick={() => {this.loadRangeEvents(); this.props.userData.getHomeVisitsLog();}} className="building-card">
                <CardBody>
                  <div>
                    <i className="now-ui-icons arrows-1_cloud-download-93" /> Buscar cambios
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>}
          {showLoadingLogMessage && <Row>
            <Col xs={12} className="text-center txt-white">
              <Card color="default">
                <CardBody>
                  <div>
                    <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando log del calendario
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>}
          {!showLoadingLogMessage && this.props.mainState.log.homeVisits["all"].length > 0 && !this.state.showLog && <Row>
            <Col xs={12} className="text-center txt-white">
              <Card color="default" style={{ cursor: "pointer" }} onClick={() => this.setState({ showLog: true })}>
                <CardBody>
                  <div>
                    <i className="now-ui-icons design_bullet-list-67" /> Mostrar log del calendario
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>}
          {!showLoadingLogMessage && this.props.mainState.log.homeVisits["all"].length > 0 && this.state.showLog && <Row>
            <Col xs={12} className="text-left">
              <Card className="card-plain log-calendario">
                <CardBody>
                  <div className="text-center">
                    <i className="now-ui-icons education_agenda-bookmark" /> Log del calendario
                  </div>
                  <table width="100%" style={{}}>
                    <tbody>
                        {this.props.mainState.log.homeVisits["all"].map(log => {
                          let date_class = "log-date ";
                          let log_date = <span className={date_class}>{moment(log.date).fromNow()}</span>;
                          let log_content = (
                            <div>
                              {log_date}
                              <div dangerouslySetInnerHTML={{ __html: log.text }} />
                            </div>
                          );
                          if (log.hasRedirect) {
                            log_content = (
                              <Link to={"/citas/" + log.redirect.id}>
                                {log_content}
                              </Link>
                            );
                          }
                          log_content = (
                            <tr key={log.id}>
                              <td className="text-left">
                                {log_content}
                              </td>
                            </tr>
                          );
                          return log_content;
                        })}
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </Col>
            </Row>}
          <Row>
            <Col xs={12} md={12} className="ml-auto mr-auto">
              <Card className="card-calendar">
                <CardBody>
                  <span className="category">{calendarRange}</span>
                  <ReactCalendar
                    ref="cal"
                    height="1350px"
                    calendars={this.props.mainState.calendarsList ? this.props.mainState.calendarsList : calendars}
                    schedules={events}
                    timezones={[
                      {
                        timezoneOffset:
                          parseInt(
                            moment()
                              .format("Z")
                              .split(":")[0]
                          ) * 60,
                        displayLabel: "GMT+01:00",
                        tooltip: "Madrid"
                      }
                    ]}
                    disableDblClick={false}
                    disableClick={true}
                    isReadOnly={false}
                    month={{
                      narrowWeekend: true,
                      startDayOfWeek: 1, // monday
                      daynames: daynames
                    }}
                    options={{
                      language: "es"
                    }}
                    scheduleViews
                    taskView={false}
                    template={{
                      milestone(schedule) {
                        // return `<span style="color:#fff;background-color: ${schedule.bgColor};">${
                        //   schedule.title
                        // }</span>`;
                        return (
                          <span style={{ color: "#FFF", backgroundColor: schedule.bgColor }}>
                            <span>
                              {schedule.title}
                            </span>
                            <span>
                              <i
                                className="now-ui-icons location_pin"
                                style={{ color: "#F00" }}
                              />
                              {" " + schedule.homeVisit.visit_locality}
                            </span>
                          </span>
                        );
                      },
                      milestoneTitle() {
                        return 'Milestone';
                      },
                      allday(schedule) {
                        // return `${schedule.title}<i class="fa fa-refresh"></i>`;
                        return schedule.title;
                      },
                      alldayTitle() {
                        return "Todo el día";
                      },
                      monthGridHeaderExceed: function(hiddenSchedules) {
                        let text = "cita";
                        if (hiddenSchedules > 1) text = "citas";
                        return '<span class="weekday-grid-more-schedules category">Hay ' + hiddenSchedules + " " + text + ' más</span>';
                      },
                      time: function(schedule) {
                        let homeVisit = null;
                        let titleStyle = null;
                        let statusIcon = null;
                        let statusTime = null;
                        let durationStyle = null;
                        let homeVisits = [];
                        if (this.props.mainState.homeVisits && this.props.mainState.homeVisits.calendar) {
                          homeVisits = this.props.mainState.homeVisits.byIdForCalendar;
                        }
                        if (parseInt(schedule.id) in homeVisits) {
                          homeVisit = homeVisits[parseInt(schedule.id)][0];
                          // console.log("homeVisit relacionado con el evento", homeVisit);
                          // console.log("homeVisit - día", homeVisit.visit_date_day);
                          // console.log("homeVisit - hora", homeVisit.visit_date_hour);
                          // console.log("schedule correspondiente", schedule);
                          // console.log("schedule - día", moment(schedule.start.getTime()).format('DD/MM/YYYY'));
                          // console.log("schedule - hora", moment(schedule.start.getTime()).format('HH:mm'));
                          titleStyle = {
                            background: this.getEventColor(homeVisit.visit_type.tid),
                            marginTop: "-1px",
                            paddingTop: "3px",
                            paddingBottom: "3px",
                            // opacity: homeVisit.opacity === "transparente" ? 0.2 : 1
                          };
                          durationStyle = {
                            background: "rgba(0,0,0,0.2)",
                            // fontWeight: 100,
                            padding: "3px 0px 3px 0px",
                            marginTop: "0px",
                            color: "#000 !important"
                            // marginBottom: "5px"
                          };
                          let homeVisitStatus = buildHomeVisitHeaderStatus(homeVisit);
                          statusIcon = homeVisitStatus.icon;
                          statusTime = homeVisitStatus.time;
                        } else {
                          console.log("error al cargar el homeVisit relacionado del evento", schedule);
                          return `Error en el evento`;
                        }
                        
                        let homeVisit_hour = homeVisit.visit_date_hour;
                        let homeVisit_day = homeVisit.visit_date_day;
                        let schedule_hour = moment(schedule.start.getTime()).format('HH:mm');
                        let schedule_day = moment(schedule.start.getTime()).format('DD/MM/YYYY');
                        try {
                          let calendar = this.refs.cal.calendarInst;
                          let showDetails = calendar.getViewName() !== "month";
                          let contentToRender = null;
                            contentToRender = 
                            <Row className={"cita-opacidad-" + homeVisit.opacity} id={this.state.lastViewed === parseInt(homeVisit.id) ? "ultimo" : ""}>
                              <Col xs={12} style={titleStyle}>
                              {statusIcon}{schedule.title}
                              </Col>
                              {showDetails && statusTime && 
                              <Col xs={12} className="text-center" style={durationStyle}>
                                {statusTime}
                              </Col>}
                              {showDetails && <Col xs={12} style={{ marginTop: "5px" }}>
                                <i
                                  className="now-ui-icons location_pin"
                                  style={{ color: "#F00" }}
                                />
                                {" " + (homeVisit ? homeVisit.visit_locality : "")}
                              </Col>}
                              {showDetails && <Col xs={12}>
                                <span style={{ color: "rgba(0,0,0,0.4)", fontSize: "12px" }}>
                                  {(homeVisit ? homeVisit.visit_address : "")}
                                </span>
                              </Col>}
                              {/* <Col xs={12} className="text-center">
                                {buildHomeVisitHeaderStatus(homeVisit)}
                              </Col> */}
                            </Row>;
                          // console.log("test event", homeVisit);
                          return ReactDOMServer.renderToStaticMarkup(contentToRender);
                        } catch (error) {
                          console.log("error al cargar el evento");
                          console.log("schedule", schedule);
                          console.log("error", error);
                          return `Error en el evento`;
                        }
                      }.bind(this),
                      popupEdit: function() {
                        return 'Abrir cita';
                      },
                      popupDelete: function() {
                        return 'Cancelar cita';
                      },
                      popupSave: function() {
                        return 'Crear cita';
                      }
                    }}
                    useDetailPopup={false}
                    useCreationPopup
                    // view={selectedView} // You can also set the `defaultView` option.
                    week={{
                      daynames: daynames,
                      narrowWeekend: true,
                      showTimezoneCollapseButton: true,
                      timezonesCollapsed: true,
                      startDayOfWeek: 1 // monday
                    }}
                    onClickSchedule={this.onClickSchedule}
                    onBeforeCreateSchedule={this.onBeforeCreateSchedule}
                    onBeforeDeleteSchedule={this.onBeforeDeleteSchedule}
                    onBeforeUpdateSchedule={this.onBeforeUpdateSchedule}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

function getReasonStyle(reason) {
  let style = {
    borderRadius: "15px",
    padding: "5px 10px",
    color: "#FFF",
    overflow: "hidden"
  };
  let icon = "";
  switch (reason) {
    // Todo correcto: verde
    case 257:
      style.background = "#00BA89";
      icon = "ui-1_check";
      break;
      // Visita pospuesta: azul
    case 261:
      style.background = "#ffb142";
      icon = "ui-1_calendar-60";
      break;
      // Incidencia ajena: amarilla
    case 260:
      style.background = "#34ace0";
      icon = "objects_support-17";
      break;
      // Incidencia propia: rojo
    case 259:
      style.background = "#b33939";
      icon = "ui-2_settings-90";
      break;
      // Cancelada: naranja
    case 258:
      style.background = "#ff793f";
      icon = "ui-1_simple-remove";
      break;    
    default:
      style.background = "#84817a";
      icon = "ui-1_settings-gear-63";
      break;
  }
  return {
    style: style,
    icon: icon
  };
}

function buildHomeVisitHeaderStatus(homeVisit) {
  // console.log("building status", homeVisit);
  let status_id = 0;
  if (homeVisit && homeVisit.visit_status) {
    homeVisit.visit_status.tid = parseInt(homeVisit.visit_status.tid);
    status_id = homeVisit.visit_status.tid;
  }
  if (homeVisit && homeVisit.visit_state) { 
    homeVisit.visit_state.tid = parseInt(homeVisit.visit_state.tid);
    status_id = homeVisit.visit_state.tid;
  }
  let style = {
    padding: "5px 10px",
    // borderRadius: "2px",
    // margin: "0px 10px 0px 5px",
    margin: "0px 5px 0px -8px",
    borderRadius: "0px",
    boxShadow: "1px 0px 1px rgba(0,0,0,0.1)"
  };
  let durationStyle = {
    // padding: "5px 10px",
    // borderRadius: "2px",
    // margin: "0px 10px 0px 5px",
    // background: "rgba(255,255,255,0.1)",
    // color: "#FFF"
  };
  let iconStyle = {
    position: "relative",
    bottom: "-1px",
    right: "-2px"
  };
  let timeIconStyle = {
    position: "relative",
    bottom: "-2px"
  };
  let visit_status = null;
  if (homeVisit && status_id) {
    switch (status_id) {
      // Cancelada
      case 250:
        visit_status = {
          text: homeVisit.visit_status_name || homeVisit.visit_state_name,
          color: "danger",
          icon: "ui-1_simple-remove"
        };
        break;
        // Esperando
      case 247:
        visit_status = {
          text: homeVisit.visit_status_name || homeVisit.visit_state_name,
          color: "info",
          icon: "ui-2_time-alarm"
        };
        break;
        // En proceso
      case 248:
        visit_status = {
          text: homeVisit.visit_status_name || homeVisit.visit_state_name,
          color: "warning",
          icon: "loader_gear spin"
        };
        if (!homeVisit.start_hour) {
          visit_status.duration = "Error en la duración";
        } else {
          let start = moment(homeVisit.start_hour, "DD/MM/YYYY HH:mm:ss");
          let end = moment();
          let durationd = end.diff(start, "days");
          let durationh = end.diff(start, "hours") - durationd*24;
          let durationm = end.diff(start, "minutes") - durationh*60 - durationd*24*60;
          let durations = end.diff(start, "seconds") - durationm*60 - durationh*3600 - durationd*24*60*60;
          durationd = durationd === 0? "" : durationd + (durationd > 1 ? " días " : " día ");
          durationh = durationh === 0? "" : durationh + (durationh > 1 ? " horas " : " hora ");
          durationm = durationm === 0? "" : durationm + (durationm > 1 ? " mins " : " min ");
          durations = durations === 0? "" : durations + (durations > 1 ? " segs " : " seg ");
          durations = "";
          let duration = (durationd + durationh + durationm + durations);
          // console.log("######## DURATION ############");
          // console.log(durationh + durationm + durations);

          visit_status.duration = (
            <span style={durationStyle}>
              <i className={"now-ui-icons ui-2_time-alarm"} style={timeIconStyle} />
              {" "}{duration}
            </span>
          );
        }
        break;
        // Finalizada
      case 249:
        // console.log("CITA FINALIZADA", homeVisit);
        visit_status = {
          text: homeVisit.visit_status_name || homeVisit.visit_state_name,
          color: "primary",
          icon: "ui-1_check"
        };
        if (homeVisit.finish_reason_name && homeVisit.finish_reason && homeVisit.finish_reason.tid) {
          let value = parseInt(homeVisit.finish_reason.tid);
          let label = homeVisit.finish_reason_name;
          let reasonStyle = getReasonStyle(value);
          let iconStyle = {
            padding: "5px 10px",
            marginRight: "10px",
            background: "rgba(0,0,0,0.1)",
            borderRadius: "15px",
            marginLeft: "-10px"
          };
          visit_status = {
            text: label,
            color: "",
            icon: reasonStyle.icon
          };
          style.background = reasonStyle.style.background;
          // return {
          //   value: value,
          //   label: (
          //     <div style={{ display: "block" }}>
          //       <span style={reasonStyle.style}>
          //         <span style={iconStyle}><i className={"now-ui-icons " + reasonStyle.icon} /></span>
          //         {label}
          //       </span>
          //     </div>)
          // }
        }
        if (!homeVisit.start_hour) {
          visit_status.duration = "Error en la duración";
        } else {
          let start = moment(homeVisit.start_hour, "DD/MM/YYYY HH:mm:ss");
          let end = moment(homeVisit.end_hour, "DD/MM/YYYY HH:mm:ss");
          let durationd = end.diff(start, "days");
          let durationh = end.diff(start, "hours") - durationd*24;
          let durationm = end.diff(start, "minutes") - durationh*60 - durationd*24*60;
          let durations = end.diff(start, "seconds") - durationm*60 - durationh*3600 - durationd*24*60*60;
          durationd = durationd === 0? "" : durationd + (durationd > 1 ? " días " : " día ");
          durationh = durationh === 0? "" : durationh + (durationh > 1 ? " horas " : " hora ");
          durationm = durationm === 0? "" : durationm + (durationm > 1 ? " mins " : " min ");
          durations = durations === 0? "" : durations + (durations > 1 ? " segs" : " seg");
          let duration = (durationd + durationh + durationm + durations);
          // console.log("######## DURATION ############");
          // console.log(durationh + durationm + durations);

          visit_status.duration = (
            <span style={durationStyle}>
              <i className={"now-ui-icons ui-2_time-alarm"} style={timeIconStyle} />
              {" "}{duration}
            </span>
          );
        }
        break;
      default:
        visit_status = {
          text: "No se pudo cargar el estado",
          color: "default",
          icon: "ui-1_simple-remove"
        };
        break;
    }
    // console.log("built status", visit_status);
    let statusIcon = (
      <span style={style} className={"bg-" + visit_status.color}>
        <i className={"now-ui-icons " + visit_status.icon} style={iconStyle}/>
        {/* {" "}{visit_status.text} */}
      </span>
    );
    let statusTime = visit_status.duration;
    return {
      icon: statusIcon,
      time: statusTime
    };
    return (
      // <div>
      //   <br />
        <span style={style} className={"bg-" + visit_status.color}>
          <i className={"now-ui-icons " + visit_status.icon} />
          {/* {" "}{visit_status.text} */}
        </span>
        // {visit_status.duration}
      // </div>
    );
  }
  return null;
}
function cancelScheduleChanges() {
  let schedule = this.state.scheduleUpdating;
  console.log("CANCEL CHANGES");
  console.log(schedule);
  let calendar = this.refs.cal.calendarInst;
  // let dateComponents = homeVisit.visit_date_day.split("/");
  // let day = parseInt(dateComponents[0]);
  // let month = parseInt(dateComponents[1]);
  // let year = parseInt(dateComponents[2]);
  // let hourComponents = homeVisit.visit_date_hour.split(":");
  // let hour = parseInt(hourComponents[0]);
  // let minutes = parseInt(hourComponents[1]);
  // let start = new Date(year, month - 1, day, hour, minutes);
  // let end = new Date(year, month - 1, day, hour, minutes);
  // end.setTime(end.getTime() + 2 * 60 * 60 * 1000);
  let changes = {
    start: schedule.start,
    end: schedule.end
  };
  console.log("CHANGES TO CANCEL", {
    schedule_id: schedule.id,
    calendar: schedule.calendarId,
    changes: changes
  });
  calendar.updateSchedule(schedule.id, schedule.calendarId, changes);
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/views/Calendar/Calendar.jsx